const routes = {
  path: 'bookings/:id',
  component: () => import('@/modules/obu_booking/index.vue'),
  children: [
    {
      path: ':type/:year/:month/details/:bookingCode',
      name: 'obu-bookings-details',
      component: () => import('@/modules/obu_booking/ObuBookingsDetails.vue'),
      children: [
        {

          path: 'edit',
          name: 'obu-bookings-edit',
          component: () => import('@/modules/obu_booking/ObuBookingsEdit.vue')
        },
        {

          path: 'edit-occupation',
          name: 'obu-bookings-edit-occupation',
          component: () => import('@/modules/obu_booking/ObuBookingsEditOccupation.vue')
        },
        {

          path: 'edit-travel-period',
          name: 'obu-bookings-edit-travel-period',
          component: () => import('@/modules/obu_booking/ObuBookingsEditTravelPeriod.vue')
        },
        {

          path: 'edit-resources',
          name: 'obu-bookings-edit-resources',
          component: () => import('@/modules/obu_booking/ObuBookingsEditResource.vue')
        }
      ]
    },
    {
      path: ':type/:year/:month',
      name: 'obu-bookings',
      component: () => import('@/modules/obu_booking/ObuBookingsView.vue'),
      children: [
        {
          path: 'create',
          name: 'obu-bookings-create',
          component: () => import('@/modules/obu_booking/ObuBookingsCreate.vue')
        }
      ]
    }
  ]
}

export default routes
